import {
  OutlinedInput as MuiOutlinedInput,
  OutlinedInputProps as MuiOutlinedInputProps,
  styled,
} from "@mui/material";

type OutlinedInputProps = MuiOutlinedInputProps & { warning?: boolean };

/**
 * MUI OutlinedInput wrapper that filters out the `warning` prop
 * to prevent it from being passed to the DOM element.
 */
export const OutlinedInput = styled(MuiOutlinedInput, {
  shouldForwardProp: (prop) => prop !== "warning",
})<OutlinedInputProps>(({ theme, warning, error }) => ({
  ...(warning &&
    !error && {
      [`& fieldset.MuiOutlinedInput-notchedOutline,
        &:hover fieldset.MuiOutlinedInput-notchedOutline,
        &.Mui-focused fieldset.MuiOutlinedInput-notchedOutline`]: {
        borderColor: theme.palette.custom.iconWarning,
      },
      "&:hover": {
        backgroundColor: theme.palette.custom.surfaceWarning,
      },
    }),
}));
